const e = {
  name: "WebinarOnDemand",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 16V4L18 10L8 16ZM14.11 10L10 7.53V12.47L14.11 10Z" fill="currentColor"/>
<path d="M17.5 5.25C17.5 4.56 18.06 4 18.75 4C19.44 4 20 4.56 20 5.25C20 5.94 19.44 6.5 18.75 6.5C18.06 6.5 17.5 5.94 17.5 5.25Z" fill="currentColor"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 4C1 2.34772 2.34772 1 4 1H20C21.6523 1 23 2.34772 23 4V16C23 17.6523 21.6523 19 20 19H4C2.34772 19 1 17.6523 1 16V4ZM4 3C3.45228 3 3 3.45228 3 4V16C3 16.5477 3.45228 17 4 17H20C20.5477 17 21 16.5477 21 16V4C21 3.45228 20.5477 3 20 3H4Z" fill="currentColor"/>
<path d="M7 23H17V21H7V23Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as WebinarOnDemand
};
